import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
import styles from './ScheduledDeletion.module.scss';
const ScheduledDeletion = ({ scheduledDeletion, outgoing }) => {
    const now = Date.now();
    const deletionTime = scheduledDeletion.timestamp;
    const msRemaining = deletionTime - now;
    // Past now
    if (msRemaining <= 0) {
        return null;
    }
    const daysRemaining = Math.ceil(msRemaining / (1000 * 60 * 60 * 24));
    const hoursRemaining = Math.ceil(msRemaining / (1000 * 60 * 60));
    return (React.createElement("div", { className: classNames(styles.scheduledDeletionWrapper, outgoing ? styles.outgoing : styles.incoming) }, daysRemaining === 0 || hoursRemaining < 24 ? (React.createElement(Trans, { i18nKey: "messageScheduledForDeletionHours", count: hoursRemaining, values: { hours: hoursRemaining } })) : (React.createElement(Trans, { i18nKey: "messageScheduledForDeletion", count: daysRemaining, values: { days: daysRemaining } }))));
};
export default observer(ScheduledDeletion);
